import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { deviceControllerIcon, deviceControllerSelectedIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type DeviceControllerIconProps = Omit<AssetIconProps, 'src' | 'alt'> & {
  selected?: boolean;
};

/** Door controller glyph — AG purple selected state; HID #0057B7 glyph unselected, #0057B7 tile + white icon when selected. */
export function DeviceControllerIcon({
  selected = false,
  size = 33,
  className,
  ...props
}: DeviceControllerIconProps) {
  const brandConfig = getBrandConfig();

  if (
    APP_BRAND === 'hid' &&
    brandConfig.hidDoorControllerUnclickedIcon &&
    brandConfig.hidDoorControllerSelectedIcon
  ) {
    return (
      <AssetIcon
        src={selected ? brandConfig.hidDoorControllerSelectedIcon : brandConfig.hidDoorControllerUnclickedIcon}
        size={size}
        className={className}
        {...props}
      />
    );
  }

  return (
    <AssetIcon
      src={selected ? deviceControllerSelectedIcon : deviceControllerIcon}
      size={size}
      className={className}
      {...props}
    />
  );
}
